import { useEffect, useState } from "react";
import axios from "axios";
import Seo from "../components/Seo";
import Marquee from "../components/Marquee";
import Hero from "../sections/Hero";
import Discovery from "../sections/Discovery";
import Numbers from "../sections/Numbers";
import Stay from "../sections/Stay";
import Experiences from "../sections/Experiences";
import Detox from "../sections/Detox";
import Wildlife from "../sections/Wildlife";
import Ramganga from "../sections/Ramganga";
import Gallery from "../sections/Gallery";
import Dining from "../sections/Dining";
import Journey from "../sections/Journey";
import Journal from "../sections/Journal";
import FinalCta from "../sections/FinalCta";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [content, setContent] = useState(null);
  const [journal, setJournal] = useState(null);

  useEffect(() => {
    axios.get(`${API}/content`).then((res) => setContent(res.data)).catch(() => {});
    axios
      .get(`${API}/journal`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) setJournal(res.data.slice(0, 3));
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="home-page" className="bg-charcoal">
      <Seo />
      <main>
        <Hero />
        <Marquee />
        <Discovery />
        <Numbers />
        <Stay />
        <Experiences items={content?.experiences} />
        <Detox />
        <Wildlife />
        <Ramganga />
        <Gallery items={content?.gallery} />
        <Dining />
        <Journey />
        <Journal entries={journal} />
        <FinalCta />
      </main>
    </div>
  );
}
